/**
 * No-Op Observability Provider
 *
 * This is a default implementation that does nothing.
 * It's used when no actual observability provider is configured,
 * preventing errors while maintaining the same interface.
 */

import type {
  ObservabilityProvider,
  ObservabilityEvent,
  ObservabilityError,
  ObservabilityMetric,
  ObservabilityUser,
  ObservabilityBreadcrumb,
} from '../../../types/observability';

export class NoOpObservabilityProvider implements ObservabilityProvider {
  captureMessage(_event: ObservabilityEvent): void {
    // No-op
  }

  captureError(_error: ObservabilityError): void {
    // No-op
  }

  recordMetric(_metric: ObservabilityMetric): void {
    // No-op
  }

  setUser(_user: ObservabilityUser | null): void {
    // No-op
  }

  addBreadcrumb(_breadcrumb: ObservabilityBreadcrumb): void {
    // No-op
  }

  setTag(_key: string, _value: string): void {
    // No-op
  }

  setContext(_name: string, _context: Record<string, unknown>): void {
    // No-op
  }

  clearContext(): void {
    // No-op
  }
}
